/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderCredentialV2ListConfiguration,
    ProviderCredentialV2ListConfigurationFromJSON,
    ProviderCredentialV2ListConfigurationToJSON,
    ProviderCredentialV2ListItemPaginationWrapper,
    ProviderCredentialV2ListItemPaginationWrapperFromJSON,
    ProviderCredentialV2ListItemPaginationWrapperToJSON,
    ProviderCredentialV2Query,
    ProviderCredentialV2QueryFromJSON,
    ProviderCredentialV2QueryToJSON,
    ProviderCredentialV2State,
    ProviderCredentialV2StateFromJSON,
    ProviderCredentialV2StateToJSON,
    ProviderCredentialV2StateResponse,
    ProviderCredentialV2StateResponseFromJSON,
    ProviderCredentialV2StateResponseToJSON,
} from '../models';

export interface ApiProviderCredentialsV2ProviderCredentialV2ListListPostRequest {
    providerCredentialV2Query?: ProviderCredentialV2Query;
}

export interface ApiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPostRequest {
    providerCredentialV2State: Array<ProviderCredentialV2State>;
}

/**
 * no description
 */
export class ProviderCredentialV2ListApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<ProviderCredentialV2ListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2List/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialV2ListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListGetListConfigurationGet(): Promise<ProviderCredentialV2ListConfiguration> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2ListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListListPostRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2ListListPostRequest): Promise<runtime.ApiResponse<ProviderCredentialV2ListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2List/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialV2QueryToJSON(requestParameters.providerCredentialV2Query),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialV2ListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListListPost(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2ListListPostRequest): Promise<ProviderCredentialV2ListItemPaginationWrapper> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2ListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPostRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<ProviderCredentialV2StateResponse>>> {
        if (requestParameters.providerCredentialV2State === null || requestParameters.providerCredentialV2State === undefined) {
            throw new runtime.RequiredError('providerCredentialV2State','Required parameter requestParameters.providerCredentialV2State was null or undefined when calling apiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2List/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.providerCredentialV2State.map(ProviderCredentialV2StateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCredentialV2StateResponseFromJSON));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPost(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPostRequest): Promise<Array<ProviderCredentialV2StateResponse>> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2ListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
